/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignInvoiceStatus } from '../../axios/campaignInvoiceStatus'
import type {
	CampaignInvoiceStatusError,
	CampaignInvoiceStatusPathParams,
	CampaignInvoiceStatusResponse,
} from '../../types/CampaignInvoiceStatus'

export const campaignInvoiceStatusQueryKey = (
	organisation: CampaignInvoiceStatusPathParams['organisation'],
	campaign: CampaignInvoiceStatusPathParams['campaign'],
) => [{ url: '/:organisation/campaign/:campaign/invoice/status', params: { organisation, campaign } }] as const

export type CampaignInvoiceStatusQueryKey = ReturnType<typeof campaignInvoiceStatusQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CampaignInvoiceController.php CampaignInvoiceController::status */
export function campaignInvoiceStatusQueryOptions(
	organisation: CampaignInvoiceStatusPathParams['organisation'],
	campaign: CampaignInvoiceStatusPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignInvoiceStatusResponse,
		AxiosError<CampaignInvoiceStatusError>,
		CampaignInvoiceStatusResponse,
		CampaignInvoiceStatusQueryKey
	>({
		queryKey: campaignInvoiceStatusQueryKey(organisation, campaign),
		queryFn: ({ signal }) =>
			campaignInvoiceStatus(organisation, campaign, { signal, ...config }).then(res => res.data),
		enabled: !!(organisation && campaign),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CampaignInvoiceController.php CampaignInvoiceController::status */
export function useCampaignInvoiceStatus<TSelectData = CampaignInvoiceStatusResponse>(
	organisation: CampaignInvoiceStatusPathParams['organisation'],
	campaign: CampaignInvoiceStatusPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignInvoiceStatusResponse,
					AxiosError<CampaignInvoiceStatusError>,
					TSelectData,
					CampaignInvoiceStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignInvoiceStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignInvoiceStatusQueryOptions(organisation, campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CampaignInvoiceController.php CampaignInvoiceController::status */
export function useCampaignInvoiceStatusSuspense<TSelectData = CampaignInvoiceStatusResponse>(
	organisation: CampaignInvoiceStatusPathParams['organisation'],
	campaign: CampaignInvoiceStatusPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignInvoiceStatusResponse,
					AxiosError<CampaignInvoiceStatusError>,
					TSelectData,
					CampaignInvoiceStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignInvoiceStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignInvoiceStatusQueryOptions(organisation, campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
